import { render } from "./ViewsApproval.vue?vue&type=template&id=bd715c74"
import script from "./ViewsApproval.vue?vue&type=script&lang=js"
export * from "./ViewsApproval.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__